import { useMediaQuery } from "@/components/gluestack/utils/use-media-query"
import React from "react"
import resolveConfig from "tailwindcss/resolveConfig"
import * as tailwindConfig from "../../tailwind.config"

const TailwindTheme = resolveConfig(tailwindConfig as any)
const mdBreakpoint = parseInt(
  TailwindTheme.theme.screens.md.replace("px", ""),
  10,
)

interface MobileOnlyProps {
  children: React.ReactNode
}

export const MobileOnly: React.FC<MobileOnlyProps> = ({ children }) => {
  const [isMobile] = useMediaQuery({ maxWidth: mdBreakpoint - 1 })

  if (!isMobile) {
    return null
  }

  return <>{children}</>
}
